var React = require('react');

function SystemSearchFull (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icons/System Search/Full"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("circle",{"id":"path-1","cx":"12.5","cy":"12.5","r":"3.5","key":2})]);
}

SystemSearchFull.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = SystemSearchFull;

SystemSearchFull.default = SystemSearchFull;
